import { configureStore } from '@reduxjs/toolkit';

import { reducer as recognitionReducer } from 'modules/recognition/slice';
import { reducer as demoReducer } from 'modules/enrollment/slice';
import { reducer as idemiaReducer } from 'modules/Idemia/slice';
import { reducer as counterReducer } from 'modules/counter/slice';

export const store = configureStore({
  reducer: {
    recognition: recognitionReducer,
    demo: demoReducer,
    idemia: idemiaReducer,
    counter: counterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
